export const CONTENT_ROUTE = 'CONTENT_ROUTE';
export const CONTENT_TYPE = 'CONTENT';
export const CONTENT_PENDING = `${CONTENT_TYPE}_PENDING`;
export const CONTENT_FULFILLED = `${CONTENT_TYPE}_FULFILLED`;
export const CONTENT_REJECTED = `${CONTENT_TYPE}_REJECTED`;
export const PREVIEW_TOKEN_CHANGED = 'PREVIEW_TOKEN_CHANGED';

export const contentActionCreator = promise => ({
  type: CONTENT_TYPE,
  payload: promise,
});

export const contentRouteCreator = uid => ({
  type: CONTENT_ROUTE,
  payload: { uid },
});

export const previewTokenChangedCreator = token => ({
  type: PREVIEW_TOKEN_CHANGED,
  payload: token,
});
